import React from 'react'
import { Container, ContainerInterno, TituloPrincipal, Subtitulo, ListaConteudos, ListaConteudosScroll, ListaConteudosItem, ListaConteudosItemInterno, ListaConteudosItemTagMelhor, ListaConteudosItemTitulo, ListaConteudosItemPorcentagem, ListaConteudosItemLegendaPorcentagem, ListaConteudosItemMesesBonus, ListaConteudosItemMentoria, ListaConteudosItemMesesAcesso, BoxDataFim, BoxDataFimSpan } from './Styled'
import { date } from '../../../../utils/formatters'

export default function ListaBonus ({ planos, dataFim }) {

    let positionItem = 0;

    const itenCard = (item, premium = false, indexPlano = 0) => {

        const position = positionItem;
        positionItem++;
        const mesesAcesso = parseInt(item.assinatura_meses) + parseInt(item.boleto.bonus);

        return <ListaConteudosItem className={'item' + position}>

            <ListaConteudosItemInterno className={'item' + position} premium={premium} indexPlano={indexPlano}>

                {/* Melhor Oferta */}
                { position === 3 ? <ListaConteudosItemTagMelhor>MELHOR OFERTA</ListaConteudosItemTagMelhor> : null }

                {/* Título */}
                <ListaConteudosItemTitulo className={ indexPlano === 1 ? 'ultimo' : '' } premium={premium}>{item.nome.split(" - ")[0].replace("Assinatura ", "")}</ListaConteudosItemTitulo>

                {/* Porcentagem Desconto */}
                <ListaConteudosItemPorcentagem><small>Até</small> {item.cartao.desconto}%</ListaConteudosItemPorcentagem>

                {/* Legenda Porcentagem */}
                <ListaConteudosItemLegendaPorcentagem>de desconto</ListaConteudosItemLegendaPorcentagem>

                {/* Meses Bônus */}
                { item.boleto.bonus ? <ListaConteudosItemMesesBonus className={'item' + position}>+ {item.boleto.bonus} { item.boleto.bonus > 1 ? 'meses' : 'mês' } de acesso grátis</ListaConteudosItemMesesBonus> : null }

                {/* Meses Mentoria */}
                { item.boleto.mentoria ? <ListaConteudosItemMentoria className={'item' + position}>+ {item.boleto.mentoria} { item.boleto.mentoria > 1 ? 'meses' : 'mês' } de Programa de Mentoria Estratégica</ListaConteudosItemMentoria> : null }

                {/* Meses de Acesso */}
                { item.assinatura_meses ? <ListaConteudosItemMesesAcesso className={'item' + position}>Total de {mesesAcesso} { mesesAcesso > 1 ? 'meses' : 'mês' }</ListaConteudosItemMesesAcesso> : null }

            </ListaConteudosItemInterno>

        </ListaConteudosItem>
    }

    return (
        <Container>
            <ContainerInterno>

                {/* Título Principal */}
                <TituloPrincipal>Quanto maior o plano, <strong>maior o bônus</strong></TituloPrincipal>

                {/* Subtítulo */}
                <Subtitulo>Renove agora e acumule meses extras de acesso e mentoria — sem pagar a mais por isso.</Subtitulo>

                {/* Lista Conteúdos */}
                <ListaConteudos>

                    <ListaConteudosScroll>

                        {/* Básica */}
                        { planos.map((plano) => {					
                            return plano.assinaturas.map((item, index) => {
                                return (
                                    index === 0 ? itenCard(item) : null
                                )
                            })
                        })}

                        {/* Premium */}
                        { planos.map((plano, indexPlano) => {					
                            return plano.assinaturas.map((item, index) => {
                                return (
                                    index === 1 ? itenCard(item, true, indexPlano) : null
                                )
                            })
                        })}

                    </ListaConteudosScroll>

                </ListaConteudos>

                <BoxDataFim>
                    <BoxDataFimSpan>OFERTA VÁLIDA SOMENTE ATÉ {date(dataFim)}</BoxDataFimSpan>
                </BoxDataFim>

            </ContainerInterno>
        </Container>
    )
}
